const THEME = {
	LIGHT: 'light',
	DARK: 'dark',
	SYSTEM: 'system',
} as const

const THEMES = [THEME.LIGHT, THEME.DARK, THEME.SYSTEM] as const

type Theme = (typeof THEMES)[number]

type Appearance = typeof THEME.LIGHT | typeof THEME.DARK

type ThemePort = {
	readonly current: () => Theme
	readonly resolved: () => Appearance
	readonly set: (theme: Theme) => void
	readonly subscribe: (listener: () => void) => () => void
}

export { THEME, THEMES }
export type { Appearance, Theme, ThemePort }
